import { message } from "antd";
import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { baseContractService, leaseService, propertyService } from "../../../../../configs/constants";
import { RootState } from "../../../../../redux/store";
import axios from "../../../../../utils/axiosInceptor";
import * as action_types from "./constants";
import { apiV1Endpoint } from "../../../../../api/v1";

const cityUrl = `${propertyService}/property/cities`;
const stateUrl = `${propertyService}/property/regions`;
const countryUrl = `${propertyService}/property/countries`;
const configUrl = `${propertyService}/configData`;

export const getTenantDetails = (id: string): ThunkAction<Promise<void>, RootState, unknown, Action<string>> => {
  return async (dispatch) => {
    dispatch({ type: action_types.GET_TENANT_DETAILS_REQUEST });

    try {
      const url = `${apiV1Endpoint}/tenant/user/${id}`;
      const response = await axios.get(url);
      dispatch({
        type: action_types.GET_TENANT_DETAILS_SUCCESS,
        data: response?.data?.result,
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_TENANT_DETAILS_FAILURE,
        error: error?.response?.data || error?.message || "Something went wrong",
      });
    }
  };
};

export const patchTenantDetails = async (userId: string, payload) => {
  try {
    const url = `${leaseService}/tenant/user/${userId}`;
    const { data } = await axios.patch(url, payload);
    message.success(data?.message);
  } catch (error) {
    console.error("Error occurred while updating tenant details", error);
    throw error;
  }
};

export const getGeoData = async () => {
  const cityData = await axios.get(cityUrl);
  const stateData = await axios.get(stateUrl);
  const countryData = await axios.get(countryUrl);
  return {
      cityData,
      stateData,
      countryData,
    }
};

export const getConfigData = async (keys) => {
    let url = `${configUrl}?key=${keys}`;

    const {
      data: { result },
    } = await axios.get(url);

    return result
};

export const getTenantNationalities = async () => {
  return await axios.get(`${baseContractService}/nationalities`)
};

export const getTenantCities = async () => {
  return await axios.get(`${propertyService}/property/cities`);
};

export const getTenantCountires = async () => {
  return await axios.get(`${propertyService}/property/countries`);

};

export const getLease = (id) => {
  return async (dispatch) => {
    const url = `${leaseService}/leads/lease/${id}/list`;
    const {
      data: { result },
    } = await axios.get(url);
    dispatch({
      type: action_types.GET_TENANT_LEASE,
      data: result,
    });
  };
};


export const getDependants = (id, lease_id) => {
  return async (dispatch) => {
    // landlord/tenant/cooccupant/userId-fc018787-dc3e-4fe3-bf0e-63c8d0ba854b
    const url = `${leaseService}/landlord/tenant/cooccupant/${id}`; ///dependants/${lease_id}`;
    const {
      data: { result },
    } = await axios.get(url);
    dispatch({
      type: action_types.GET_DEPENDENTS,
      data: result,
    })
  }
}
  

export const emptyTenantDetail = () => {
  return (dispatch) => {
    dispatch({
      type: action_types.GET_EMPTY,
      data: {},
    });
  };
};
